import Box from './layout/Box';
import Icon from './Icon';
import Text from './Text';

const ErrorBox = ({ title, text }) => {
  return (
    <Box
      backgroundColor="errorColor"
      className="px-3 py-3 mb-3 d-flex flex-row"
      style={{ borderRadius: 4 }}
    >
      <div
        className="d-flex align-items-center justify-content-center"
        style={{ marginRight: 12 }}
      >
        <Icon name="alert-triangle-outline" color="#fff" size={30} />
      </div>

      <div className="d-flex flex-column flex-grow-1" style={{ minWidth: 0 }}>
        <Text
          variant="notificationTitle"
          style={{ fontWeight: 600 }}
          color="whiteColor"
        >
          {title}
        </Text>
        <Box
          style={{
            minWidth: 0,
          }}
        >
          <Text variant="notificationText" color="whiteColor">
            {text}
          </Text>
        </Box>
      </div>
    </Box>
  );
};

ErrorBox.defaultProps = {
  title: 'Felmeddelande',
  text: 'Okänt fel, försök gärna igen.',
};

export default ErrorBox;
